module.exports = "<div class=\"c-toggle\">\n    <div class=\"c-toggle__options-wrapper\">\n        <button class=\"c-toggle__option\" :class=\"{'is-selected': option.value == selected}\" v-for=\"option in options\" @click=\"toggle(option)\" @keyup.enter=\"toggle(option)\"><span>{{option.label}}</span></button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/toggle-stateless/toggle-stateless.vhtml
// module id = 316
// module chunks = 0